"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Group = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var Group = _styledComponents["default"].div.withConfig({
  displayName: "Groupstyles__Group",
  componentId: "sc-1ljnpbp-0"
})(function (_ref) {
  var zIndex = _ref.zIndex,
      offsetY = _ref.offsetY;
  return (0, _styledComponents.css)(["box-sizing:border-box;display:flex;height:100%;justify-content:flex-end;position:fixed;right:0;top:", "px;visibility:hidden;width:100%;z-index:", ";> div[role=\"dialog\"]{visibility:visible;}"], offsetY, zIndex);
});

exports.Group = Group;
//# sourceMappingURL=Group.styles.js.map